import "./Testimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../assetsprogressive/button.png";
import symbol from "../assetsprogressive/symbol.png";
import f1 from "../assetsprogressive/f1.png";
import f2 from "../assetsprogressive/f2.png";
import f3 from "../assetsprogressive/f3.png";
const Feedback = () => {
  const data = [
    {
      id: 1,
      image: f1,
      name: "Vaibhav",
      position: "— Tech Startup",
      feedback:
        "Bastionex’s CRM automated our lead tracking and reporting, saving our team hours every week and letting us focus on closing deals.",
    },
    {
      id: 2,
      image: f2,
      name: "Priya Sharma",
      position: "— Pharma Company",
      feedback:
        "We love how Bastionex’s user-friendly CRM boosted our productivity and gave us a complete 360° view of our customers, helping us make faster, smarter decisions every day.",
    },
    {
      id: 3,
      image: f3,
      name: "Alex Lee",
      position: "— Sales Executive",
      feedback:
        "We admire that Bastionex built a custom CRM that fits our unique workflows perfectly, with the scalability to support our growth and daily operations seamlessly.",
    },
    {
      id: 4,
      image: f2,
      name: "Samantha",
      position: "— Tech Agency",
      feedback:
        "Bastionex provides regular updates and optimizations, keeping our CRM running smoothly and our customer management processes seamless.",
    },
  ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id='testimonials' className="progressive-wrapper">
       <div className="container-main">
            <h2 className="heading">
              What Our Client Says
            </h2>
            {/* <p className="subHeading">
            We build trust through proven client experiences, delivering reliable CRM solutions that drive measurable results and long-term business growth.
            </p> */}
            <Slider {...settings}>
                {data.map((item) => {
                    return (
                        <div className="fwrapper" key={item.id}>
                            <div className="fbox">
                                <div className="symbolbox">
                                    <img src={symbol} alt="" className="symbolimage" />
                                </div>
                                <div className="fcontent">
                                    <p>{item.feedback}</p>
                                    <div className="personinfo">
                                        <h3>{item.name}</h3>
                                        <h4>{item.position}</h4>
                                    </div>
                                </div>
                                <div className="profilebox">
                                    <img src={item.image} alt="" className="profileimage" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
    </div>
</div>
  );
};

export default Feedback;
